import _ from 'lodash'

const defaultState = {
  current: null,
  selectKey: null

}
const cmdbReducer = (state = defaultState, action) => {
  if (action.type == '@@cmdb/CHANGE_CURRENT') {
    return {
      ...state,
      current: action.id,
      // 基本信息tab保存key与其他tab保存key
      selectKey: action.selectKey || state.selectKey
    }
  }
  return state
}
export default {
  cmdb: cmdbReducer
}
